import { pipe, pluck, sum } from "ramda";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { Maybe } from "true-myth";

import LaborDrawer from "components/labor/labor_drawer";

import {
  getScheduleCostPerDay,
  LaborCostsPerDay,
  CategoryCosts,
} from "helpers/insights/labor_costs";
import { selectSalesForecast } from "store/select/account";
import { selectRawSchedule } from "store/select/scheduling";
import { ISalesForecast } from "types/account";

interface IPropsFromState {
  costsPerDay: LaborCostsPerDay;
  salesForecast: Maybe<ISalesForecast>;
  totalCost: number;
}

const getTotalCost = pipe<LaborCostsPerDay, CategoryCosts[], number[], number>(
  (costsPerDay) => Array.from(costsPerDay.values()),
  pluck("Total"),
  sum
);

const mapStateToPropsSelector = createSelector(
  selectRawSchedule,
  selectSalesForecast,
  (schedule, salesForecast): IPropsFromState => {
    const costsPerDay = getScheduleCostPerDay(schedule);
    const totalCost = getTotalCost(costsPerDay);
    return {
      costsPerDay,
      salesForecast,
      totalCost,
    };
  }
);

export default connect(mapStateToPropsSelector)(LaborDrawer);
